import { StyleSheet, Text, View } from 'react-native'
import React from 'react'
import './module.css'; // make sure file name is exactly 'module.css'
import { Ionicons } from '@expo/vector-icons';
type Props = {
    value?: string; // optional value
    onValueChange?: (value: string) => void; // optional callback
    hint: string; // placeholder text
    title: string; // label/title,
    useEye?: boolean,
    eyeState?: boolean;          // 👈 controlled state
    toggleEye?: () => void;      // 👈 controlled toggle
};

export default function LabledTextField(prop: Props) {


    return (
        <View style={styles.root}>
            <Text style={styles.title}>{prop.title}</Text>
            <View style={styles.textFieldandeye}>
                <input
                    id="inputField"
                    type={prop.useEye ? (prop.eyeState ? 'text' : 'password') : 'text'}
                    placeholder={prop.hint}
                    className="customInput"
                    value={prop.value}
                    onChange={prop.onValueChange ? (e) => prop.onValueChange!(e.target.value) : undefined}
                />
                {prop.useEye &&
                    <Ionicons
                        name={prop.eyeState ? "eye" : "eye-off"}
                        size={20}
                        color="#555"
                        onPress={prop.toggleEye ?? (() => { })}
                        style={{
                            position: 'absolute',
                            right: "10%",
                            top: '50%',
                            transform: 'translateY(-50%)',

                        }}

                    />
                }
            </View>
        </View>
    )
}

const styles = StyleSheet.create({
    title: {
        color: "#695C5C",
        marginLeft: 3
    }
    ,
    root: {
        gap: 5
    }
    ,
    textFieldandeye: {
        flexDirection: "row",
        alignItems: "center"
    }
})